<template>
  <MultipleSelect
    data-private
    data-testid="tags-selector"
    itemValue="id"
    :disabled="disabled"
    :label="resolvedLabel"
    :loading="loading"
    :options="tagsOptions"
    :required="required"
    :showSelectAll="false"
    :value="value"
    @change="onChangeTags"
  />
</template>

<script>
import { utils } from 'frontend-js-shared'
import { mapGetters } from 'vuex'
import _ from 'lodash'

import mixin from '@/mixins/mixin.vue'

import MultipleSelect from '@/components/Core/MultipleSelect.vue'

export default {
  name: 'TagsSelector',

  mixins: [mixin],

  components: {
    MultipleSelect,
  },

  props: {
    disabled: Boolean,

    onlyGlobal: Boolean,

    value: {
      type: Array,
      default: () => [],
    },

    presetTags: {
      type: Array,
      required: false,
    },

    allowedTags: {
      type: Array,
      required: false,
      default: () => [],
    },

    siteId: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      required: false,
    },

    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    ...mapGetters(['organizationTags']),

    resolvedLabel() {
      const base = this.label || this.$t('common.tag_other')
      return this.required ? `${base}*` : base
    },

    availableTagIds() {
      return this.allowedTags?.map?.(tag => utils.getEntityId(tag)) ?? []
    },

    tagsOptions() {
      const tagsByScope = this.onlyGlobal
        ? this.organizationTags?.filter?.(tag =>
            tag?.sites ? tag?.sites?.length === 0 : true
          )
        : this.organizationTags?.filter?.(tag =>
            tag?.sites
              ? this.siteId === tag?.sites?.[0] || tag?.sites?.length === 0
              : true
          )

      if (_.isEmpty(this.availableTagIds)) {
        return _.sortBy(tagsByScope, 'name')
      }

      if (this.onlyGlobal) {
        return _.sortBy(
          tagsByScope?.filter?.(tag =>
            this.availableTagIds.includes(utils.getEntityId(tag))
          ),
          'name'
        )
      }

      return _.sortBy(
        tagsByScope?.filter?.(tag =>
          this.availableTagIds.includes(utils.getEntityId(tag))
        ),
        'name'
      )
    },
  },

  methods: {
    onChangeTags(value = []) {
      this.$emit('change', {
        tags: value,
      })
    },
  },
}
</script>
